<template>
  <div class="c-credit-card c-page payment-form">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--6">
        <h1 class="f-headline"><strong>Nu er vi</strong> tæt på hinanden</h1>

        <div class="l-columns-container">
          <div class="l-laptop-column--8">
            <div>
              <p class="f-text">
                Indtast de betalingsoplysninger, der skal knyttes til dit
                abonnement. Du kan opsige når som helst. Der er ingen binding.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="l-tablet-column--6">
        <div class="c-form">
          <div id="pay-button" ref="paybutton" class="button"></div>
          <div id="credit-card-wrapper" ref="card" class="c-credit-card__card">

          </div>
          <br />
          <div id="card-errors">{{ errorMessage }}</div>

          <SpinnerButton
            ref="connect"
            class="c-form__submit"
            cta="Tilknyt betalingskort"
            action="Tilknytter"
            @clickaction="connect"
          />
        </div>
      </div>

      <!-- <button v-on:click="connect">Tilknyt betalingskort</button> -->
    </div>
  </div>
</template>

<script>
import SpinnerButton from "@/components/SpinnerButton.vue";
import stripeTranslations from "@/components/StripeTranslations.js";

// eslint-disable-next-line
let stripe = Stripe(process.env.VUE_APP_STRIPE_KEY),
  elements = stripe.elements(),
  card = undefined;

export default {
  components: {
    SpinnerButton,
  },
  data() {
    return {
      redirect: this.$route.query.redirect || null,
      query: this.$route.query,
      user: this.$route.meta.user,
      complete: false,
      errorMessage: "",
      stripeOptions: {
        hidePostalCode: true,
        style: {
          base: {
            color: "#32325d",
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "#aab7c4",
            },
            /*backgroundColor: "#ffffff",
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: '#000000'*/


          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
          },
        },
      },
    };
  },
  mounted: function() {
    this.$userService
      .refreshLocalUser()
      .then((user) => {
        this.user = user;
        return this.$userService.getIntent();
      })
      .then((intent) => {
        this.intent = intent.data;

        this.card = elements.create("card", this.stripeOptions);
        this.card.mount(this.$refs.card);
        this.card.addEventListener("change", function(event) {
          var displayError = document.getElementById("card-errors");
          console.log(event);
          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = "";
          }
        });
        console.log(stripe)
        console.log(stripe.paymentRequest)
        const paymentRequest = stripe.paymentRequest({
          country: 'DK',
          currency: 'dkk',
          total: {
            label: 'Subscription',
            amount: 0, // Amount in cents
          },
          /*
          requestPayerName: false,
          requestPayerEmail: false,
          requestShipping: false,
          paymentMethodTypes: ['card'],
          lineItems: [
            { label: 'Subscription', amount: 1000, pending: true },
          ],*/
        });
        const user = this.user;
        const that = this;
        paymentRequest.on('paymentmethod', (ev) => {
          console.log(ev)
          console.log(user);
          if (ev.paymentMethod.id) {
            ev.complete('success');

            that.connect(ev.paymentMethod.id)
          } else {
            ev.complete('fail');
          }

        });
        paymentRequest.canMakePayment().then(data => {

          console.log(data)
          console.log(paymentRequest)
          this.prButton = elements.create('paymentRequestButton',
            { paymentRequest: paymentRequest }
          );
          this.prButton.mount(this.$refs.paybutton);
        })

      });
  },
  beforeDestroy() {
    this.card.destroy();
    this.prButton.destroy();
  },
  methods: {
    connect(pm) {
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.

      console.log(this.intent);
      console.log(this.user);

      let paymentMethod = {
        card: this.card,
        /*billing_details: {
          name: cardholderName.value,
        },*/
      };
      if (pm) {
        paymentMethod = pm;
      }

      stripe
        .confirmCardSetup(this.intent.client_secret, {
            payment_method: paymentMethod
        })
        .then((result) => {
          if (result.error) {
            console.log("error");
            console.error(result.error);
            // Display error.message in your UI.
            this.$refs.connect.reset();
            var errorElement = document.getElementById("card-errors");
            errorElement.textContent = result.error.message;
          } else {
            this.$userService
              .updatePaymentMethod(result.setupIntent.payment_method)
              .then((data) => {
                console.log("tata");
                console.log(data);

                if (data.status == 200) {
                  if (this.redirect) {
                    if (this.redirect === "landing" || this.redirect === "article") {
                      this.$userService
                        .subscribe()
                        .then((data) => {
                          console.log("subsc");
                          console.log(data);
                          this.$userService
                            .getCustomer()
                            .then((subscription) => {
                              console.log(subscription);
                              const params =
                              this.$router.push(
                                {
                                  name: this.redirect,
                                  query: this.query,
                                },
                                () => {
                                  return;
                                }
                              );
                            });
                        })
                        .catch((err) => {
                          this.$router.push(
                            { name: "creditcard", query: this.query },
                            () => {
                              return;
                            }
                          );
                        });
                    } else {
                      this.$router.push(
                        { name: this.redirect, query: this.query },
                        () => {
                          return;
                        }
                      );
                    }
                  } else {
                    this.$router.push({ name: "subscription" }, () => {
                      return;
                    });
                  }
                } else {
                  this.$refs.connect.reset();
                  this.errorMessage = response.data.raw.message;
                  var displayError = document.getElementById("card-errors");

                  const code = response.data.code;
                  console.log(stripeTranslations);
                  displayError.textContent =
                    code in stripeTranslations
                      ? stripeTranslations[code]
                      : response.data.raw.message;
                }
              })
              .catch((err) => {
                this.$refs.connect.reset();
                var errorElement = document.getElementById("card-errors");
                errorElement.textContent = err;
              });

            // The setup has succeeded. Display a success message.
          }
        });
      /*
      stripe.createToken(this.card).then((result) => {
        if (result.error) {
          // Inform the user if there was an error
          this.$refs.connect.reset();
          var errorElement = document.getElementById("card-errors");
          errorElement.textContent = result.error.message;
        } else {
          // Send the token to your server

          this.$userService
            .updateSource(result.token)
            .then((response) => {
              console.log(response);
              if (
                response.data &&
                response.data.statusCode &&
                response.data.statusCode != 200
              ) {
                // HTTP OK, BUT STRIPE ERROR
                //alert(response.data.raw.message);
                this.$refs.connect.reset();
                this.errorMessage = response.data.raw.message;
                var displayError = document.getElementById("card-errors");

                const code = response.data.code;
                console.log(stripeTranslations);
                displayError.textContent =
                  code in stripeTranslations
                    ? stripeTranslations[code]
                    : response.data.raw.message;
              } else {
                if (this.redirect) {
                  if (this.redirect === "landing") {
                    this.$userService
                      .subscribe()
                      .then((data) => {
                        console.log("subsc");
                        console.log(data);
                        this.$userService.getCustomer().then((subscription) => {
                          console.log(subscription);
                          this.$router.push(
                            {
                              name: "landing",
                              query: { redirect: "landing" },
                            },
                            () => {
                              return;
                            }
                          );
                        });
                      })
                      .catch((err) => {
                        this.$router.push(
                          { name: "creditcard", query: this.query },
                          () => {
                            return;
                          }
                        );
                      });
                  } else {
                    this.$router.push(
                      { name: this.redirect, query: this.query },
                      () => {
                        return;
                      }
                    );
                  }
                } else {
                  this.$router.push({ name: "subscription" }, () => {
                    return;
                  });
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });*/
    },
  },
};
</script>

<style scoped lang="scss">
.c-credit-card {
  &__card {
    width: 100%;
  }
}
#pay-button {
  width: 140px;
  margin-bottom: 20px;
}

#pay-button.StripeElement::after {
    content: 'Eller:';
    display: block;
    margin-top: 15px;
}
.card-form-wrapper {
  max-width: 400px;
  margin: 0 auto 20px;
}
.stripe-card {
  width: 300px;
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
button {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
}
#card-errors {
  min-height: 40px;
  margin-bottom: 20px;
}
#credit-card-wrapper  {
  height: 31px;
  border: 1px solid #e9ebed;
  padding: 4px;
  border-radius: 5px;
}
</style>
